import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAuth } from '@clerk/clerk-react';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { apiJson } from '@/lib/api';
import { track } from '@/lib/analytics';
import type { UserResponse } from '@/lib/types';
import { ChatView } from '@/components';

function MainChatPage() {
  const { getToken, isLoaded, isSignedIn } = useAuth();
  const navigate = useNavigate();

  // Track screen view
  useEffect(() => {
    track('Main Chat Screen');
  }, []);

  // Fetch user
  const userQuery = useQuery({
    queryKey: ['user'],
    queryFn: () => apiJson<UserResponse>(getToken, '/v1/user'),
    enabled: isLoaded && !!isSignedIn,
  });

  const handleBack = () => {
    // Navigate back to chat list
    navigate({ to: '/app/chat' });
  };

  return (
    <div className='flex h-dvh flex-col overflow-hidden bg-sky-light'>
      <ChatView
        conversation={{ type: 'main' }}
        currentUser={userQuery.data}
        onBack={handleBack}
        showHeader={true}
      />
    </div>
  );
}

export const Route = createFileRoute('/app/chat/main')({
  component: MainChatPage,
});
